module.exports = __webpack_public_path__ + "img/Detach.a4888628.svg";